module.exports = __webpack_public_path__ + "assets/img/dough_active.16e1a86c.png";